import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { openAccordion,closeAccordion } from 'shared/assets/icons';

import { resetBreadcrumbs } from '../breadcrumbs/Breadcrumbs';

import './Accordion.scss';
import { addDataLayer } from 'shared/utils/utils';

export const Accordion = ({ props, menuData, asDropdown=false }) => {  
      const dispatch = useDispatch();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const user = useSelector(state => state.user);

    const [menus, setMenus] = useState([]);

    useEffect(() => {
        if ( asDropdown ) {
            let sideMenus = [];
            menuData.forEach(menu => {
                if ( menu.showOrHide ) {
                    if ( menu.showOrHide(user) ) {
                        sideMenus.push(menu);
                    }
                } else {
                    sideMenus.push(menu);
                }
            });
            setMenus(sideMenus);
        } else {
            if ( user.id ) {
                let sideMenus = [...menuData];
                if ( user.membershipCompleted === 1 ) {
                    const index = sideMenus.findIndex(menu => menu.type === 'link' && menu.redirectTo.endsWith('/join-premier-member'));
                    if ( index > -1 ) {
                        sideMenus.splice(index, 1);
                    }
                } else {
                    const index = sideMenus.findIndex(menu => menu.type === 'link' && menu.redirectTo.endsWith('/member-benefits'));
                    if ( index > -1 ) {
                        sideMenus.splice(index, 1);
                    }
                }
                setMenus(sideMenus);
            }
        }
    },[user.id,  props.location.pathname]);

    const onClickItem = (menu) => {
        let dataLayerData = {
            'event': menu.dataLayer
        }
        addDataLayer(dataLayerData);
        
        setIsDropdownOpen(false);
        resetBreadcrumbs();
        dispatch({
            type: 'PUSH_TO_STATE', payload: {}
        });
    };
    const onClickLink = () => {
        dispatch({
            type: 'PUSH_TO_STATE', payload: {}
        });
    };

    return (
        <div className='accordion-box'>
            {isDropdownOpen && (<div style={{ position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1000 
                }} />)}
            {
                asDropdown ? 
                <Dropdown className={`quick-link`} show={isDropdownOpen} onToggle={() => setIsDropdownOpen(!isDropdownOpen)}>
                    <Dropdown.Toggle id="quickLinks" as="div" style={{ cursor: 'pointer' }} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                       { <img  src={`${process.env.PUBLIC_URL}/static/icons/header/${isDropdownOpen ? 'close.png' : 'menu.png'}`} alt="menu-image" height="25px" width="25px" onClick={() => {}} />}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="shadow" >
                        {
                            menus.map((menu, mIndex) => 
                                <Dropdown.Item key={"dropdowm-menu-" + mIndex} className='menu-box' style={{ textDecoration: 'none' }}  onClick={() => {onClickItem(menu)}}>
                                    {
                                        menu.type === 'link' ? 
                                        <Link className={`menu ${props.location.pathname.includes(menu?.include) ? 'active': ''}`} to={menu.redirectTo}  onClick={onClickLink}>{menu.label}</Link > :  
                                        <div className={`menu`} onClick={() => { menu.callback && menu.callback(menu); }}>
                                            { menu.label }
                                            { menu.icon ? menu.icon(user) : null }
                                        </div>
                                    }
                                    {
                                        props.location.pathname.includes(menu?.include) && Array.isArray(menu.sub_menu) && menu.sub_menu.length > 0 ?
                                            <div className='sub-menu-box'>
                                                {
                                                    menu.sub_menu.map((subMenu, smIndex) =>
                                                        <Link to={subMenu.redirectTo} key={'dropdowm-sub-menu-' + smIndex} className={`sub-menu ${props.location.pathname.includes(subMenu?.include) ? 'active' : ''}`} role='button'  onClick={onClickLink}>
                                                            <div>{subMenu.label}</div>
                                                            {
                                                                (subMenu.label === 'Payment Methods' && user.paymentcompleted === 0) ||
                                                                (subMenu.label === 'Personal Interests' && user.interestCompleted === 0) ||
                                                                (subMenu.label === 'Personal Info' && user.profilecompleted === 0) ?
                                                                <div className='d-flex align-items-center justify-content-center bg-danger text-white rounded-circle text-center' style={{ width: '20px', height: '20px', fontWeight: 900 }}>!</div> : null
                                                            }
                                                        </Link>
                                                    )
                                                }
                                            </div> : null
                                    }
                                </Dropdown.Item>
                            )
                        }
                    </Dropdown.Menu>
                </Dropdown> :
                menus.map((menu, mIndex) => 
                    <div className='menu-box' key={"sidebar-menu-" + mIndex}>
                        <Link to={menu.redirectTo} className={`menu ${props.location.pathname.includes(menu?.include) ? 'active': ''}`} role='button'  onClick={onClickLink}>
                            <div className='label'>{menu.label}</div>
                            {
                                Array.isArray(menu.sub_menu) && menu.sub_menu.length > 0 ? 
                                <div className='arrow-icon'>
                                    {props.location.pathname.includes(menu?.include) ? openAccordion : closeAccordion}
                                </div> : null
                            }
                        </Link>
                        {
                            props.location.pathname.includes(menu?.include) && Array.isArray(menu.sub_menu) && menu.sub_menu.length > 0 ? 
                            <div className='sub-menu-box'>
                                {
                                    menu.sub_menu.map((subMenu, smIndex) => 
                                        <Link to={subMenu.redirectTo} key={'sidebar-sub-menu-' + smIndex} className={`sub-menu ${props.location.pathname.includes(subMenu?.include) ? 'active': ''}`} role='button'  onClick={onClickLink}>
                                            <div>{subMenu.label}</div>
                                            {
                                                (subMenu.label === 'Payment Methods' && user.paymentcompleted === 0) ||
                                                (subMenu.label === 'Personal Interests' && user.interestCompleted === 0) ||
                                                (subMenu.label === 'Personal Info' && user.profilecompleted === 0) ?
                                                <div className='d-flex align-items-center justify-content-center bg-danger text-white rounded-circle text-center' style={{ width: '20px', height: '20px', fontWeight: 900 }}>!</div> : null
                                            }
                                        </Link>
                                    )
                                }
                            </div> : null
                        }
                    </div>
                )
            }
        </div>
    )
};